export default __webpack_public_path__ + "static/media/YanoneKaffeesatz-Regular.0bd43f8d.ttf";